<ng-container *ngIf="data && data.length; else emptyMessage">
    <gen-v-scroller class="full-width"
        [rows]="data"
        [rowTemplate]="rowTemplate"
    ></gen-v-scroller>
</ng-container>


<ng-template #emptyMessage>
    <div class="no-items-message">{{'No clinical recommendation for the genes and aberrations you selected' | stringTranslate}}</div>
</ng-template>


<ng-template let-row='row' #rowTemplate>
    <gen-expandable-information-card
        [testId]="testId"
        [data]="row"
        [titles]="panelConfiguration.titles"
        [cssClass]="panelConfiguration.cssClass"
        [indexProperty]=panelConfiguration.indexProperty
        [editable]="panelConfiguration.editable"
        [isSelectable]="panelConfiguration.selectAvailable"
        [additionalData]="panelConfiguration.additionalData"
        (onSelect)="addToSelection($event)"
        (onDeselect)="removeFromSelection($event)"
    ></gen-expandable-information-card>
</ng-template>

